import React from "react";
import {Card, Col, Row} from "react-bootstrap";
import HelpTooltip from "../HelpTooltip.jsx";
import {formatEuro, formatQuantity} from "./format.js";

/**
 * Kennzahlen-Kacheln der Seite "Entgangener Umsatz" - die Summenzeile, die
 * Jürgen laut Freigabe 22.09.2026 in erster Linie sehen wollte ("was hätten
 * wir dann an Umsatz [gehabt]"). Die Kachel zur Preisgrundlage trägt das
 * Wort „Brutto"/„Netto" direkt im Kachel-Titel (Vorgabe: an der Zahl, nicht
 * nur im Tooltip). Die Warnkachel zu fehlenden Preisen verschwindet
 * vollständig, wenn sie 0 ist (Hausvorgabe: leere Bausteine nie anzeigen).
 */
export default function EntgangenerUmsatzKacheln({summe, preisgrundlage, farbtoneAnzahl, artikelOhnePreis}) {
    const wertebasisLabel = preisgrundlage === "netto" ? "Netto" : "Brutto";

    return (
        <Row xs={1} sm={2} lg={artikelOhnePreis > 0 ? 4 : 3} className="g-3 mb-3">
            <Col>
                <Card className="h-100 shadow-sm">
                    <Card.Body>
                        <div className="d-flex align-items-center justify-content-between">
                            <span className="text-muted small text-uppercase">Entgangener {wertebasisLabel}umsatz</span>
                            <HelpTooltip placement="left" size={0.75}>
                                Summe des geschätzten entgangenen Umsatzes über alle Farbtöne im gewählten Zeitraum,
                                zum {wertebasisLabel.toLowerCase()}en Verkaufspreis.
                            </HelpTooltip>
                        </div>
                        <div className="fs-3 fw-semibold lh-sm mt-1">{formatEuro(summe?.umsatz_entgangen ?? 0)}</div>
                        <div className="small text-muted mt-1">{wertebasisLabel}, geschätzt</div>
                    </Card.Body>
                </Card>
            </Col>
            <Col>
                <Card className="h-100 shadow-sm">
                    <Card.Body>
                        <div className="d-flex align-items-center justify-content-between">
                            <span className="text-muted small text-uppercase">Entgangene Menge</span>
                            <HelpTooltip placement="left" size={0.75}>
                                Geschätzte Anzahl Dosen, die zusätzlich hätten verkauft werden können, wäre der
                                jeweilige Farbton durchgehend lieferbar gewesen.
                            </HelpTooltip>
                        </div>
                        <div className="fs-3 fw-semibold lh-sm mt-1">{formatQuantity(summe?.menge_entgangen ?? 0)} Stk.</div>
                    </Card.Body>
                </Card>
            </Col>
            <Col>
                <Card className="h-100 shadow-sm">
                    <Card.Body>
                        <div className="d-flex align-items-center justify-content-between">
                            <span className="text-muted small text-uppercase">Betroffene Farbtöne</span>
                            <HelpTooltip placement="left" size={0.75}>
                                Anzahl Farbtöne mit mindestens einer Woche entgangenem Umsatz im gewählten Zeitraum.
                            </HelpTooltip>
                        </div>
                        <div className="fs-3 fw-semibold lh-sm mt-1">{formatQuantity(farbtoneAnzahl ?? 0)}</div>
                    </Card.Body>
                </Card>
            </Col>
            {artikelOhnePreis > 0 && (
                <Col>
                    <Card className="h-100 shadow-sm border-warning">
                        <Card.Body>
                            <div className="d-flex align-items-center justify-content-between">
                                <span className="text-muted small text-uppercase">Ohne hinterlegten Preis</span>
                                <HelpTooltip placement="left" size={0.75}>
                                    Für diese Farbtöne fehlt ein B2B-Verkaufspreis (article_prices) - die entgangene
                                    Menge fließt in die Summe „Entgangene Menge" ein, aber NICHT in den Euro-Betrag.
                                </HelpTooltip>
                            </div>
                            <div className="fs-3 fw-semibold lh-sm mt-1 text-warning-emphasis">{formatQuantity(artikelOhnePreis)}</div>
                            <div className="small text-muted mt-1">Umsatzschätzung dafür unvollständig</div>
                        </Card.Body>
                    </Card>
                </Col>
            )}
        </Row>
    );
}
